<div class="page">
    <app-header title="{{ 'documentsGrid.detailsPageTitle' | translate }}"> </app-header>
    <ngx-loading [show]="showSpinner"></ngx-loading>
    <div class="page-content">
        <div class="table-top">
            <div class="section-header">
                {{ "documentsGrid.detailsPageTitle" | translate }}
            </div>
        </div>
        <div class="table-body">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGridDetails.constancyType" | translate }}
                        </label>
                        <input type="text" name="constancyName" class="form-control text-uppercase"
                            disabled="true" [(ngModel)]="documentProcess.constancyType">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGridDetails.constancyNumber" | translate }}
                        </label>
                        <input type="text" name="constancyNumber" class="form-control text-uppercase"
                            disabled="true" [(ngModel)]="documentProcess.constancyNumber"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGrid.numberOfInscription" | translate }}
                        </label>
                        <input type="text" name="registrationNumber" class="form-control text-uppercase"
                            disabled="true" [(ngModel)]="documentProcess.registrationNumber"/>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGrid.fileUploadDate" | translate }}
                        </label>
                        <input type="text" name="documentUploadDate" class="form-control text-uppercase" disabled="true"
                            [value]="documentProcess.documentProcessCreateDate" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGrid.fileName" | translate }}
                        </label>
                        <input type="text" name="documentName" class="form-control text-uppercase" disabled="true"
                            [(ngModel)]="documentProcess.documentName" />
                    </div>
                </div>

                <div class="col-md-6" *ngIf="explorerUrl">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGridDetails.notarizationLink" | translate }}
                        </label>
                        <div class="form-control notarization-link-container">
                            <a [href]="explorerUrl" target="_blank" rel="noopener noreferrer" class="notarization-url">
                                {{ explorerUrl }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-control-label">
                            {{ "documentsGrid.fileHash" | translate }}
                        </label>
                        <input type="text" name="documentHash" class="form-control text-uppercase" disabled="true"
                            [(ngModel)]="documentProcess.documentHash" />
                    </div>
                </div>
            </div>

            <table class="table table-striped table-bordered">
                <thead>
                  <tr class="table-names">
                    <th>{{ "documentsGridDetails.sintraId" | translate }}</th>
                    <th>{{ "documentsGridDetails.tableAssignTo" | translate }}</th>
                    <th>{{ "documentsGridDetails.tableSignatoryName" | translate }}</th>
                    <th>{{ "documentsGridDetails.tableSignatoryEmail" | translate }}</th>
                    <th>{{ "documentsGridDetails.tableStatus" | translate }}</th>
                    <th>{{ "documentsGridDetails.tableUpdateDate" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let group of documentsByOrganization | keyvalue">
                    <tr *ngFor="let item of group.value; let i = index">
                        <ng-container *ngIf="i === 0">
                            <td [attr.rowspan]="group.value.length" class="text-center"> {{ group.key }} </td>
                        </ng-container>
                        <td class="text-center"> {{ item.assignedToName }} </td>
                        <td class="text-center"> {{ item.signatoryName && item.signatoryName !== '' ? item.signatoryName : item.firstName }} </td>
                        <td class="text-center"> {{ item.signatoryEmail && item.signatoryEmail !== '' ? item.signatoryEmail : item.email }} </td>
                        <td class="text-center"> {{ documentProcessToStatusGridTranslate.get(item.status) | translate }} </td>
                        <td class="text-center"> {{ item.updateDate }} </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>

            <file-container #fileContainer *ngIf="documentProcess">
                <filedescriptor [(fileDescriptorId)]="documentProcess.documentFileDescriptorId"
                    fileColumnClass="col-md-12" maxSize="41943040" isEncrypted="false" [showPreview]="true" [disabled]="true"
                    [showAsRequired]="false">
                </filedescriptor>
            </file-container>
        </div>
        <div class="table-bottom">
            <div class="row">
                <div *ngIf="documentProcess.isSignatory && isvisible" class="col-md-12 text-right">
                    <app-button [title]="'documentsGrid.signDocument' | translate" (buttonClick)="signDocument()"
                    [info]="signatureMessageTooltipTitle()"
                    [disable]="disabedSignButton" icon="fa-plus">
                    </app-button>
                </div>
            </div>
        </div>
        <div>
            <button type="button" class="btn btn-sm" (click)="redirect()" >
        
              {{ "documentsGrid.backButton" | translate}}
              
        </button>
        </div>
    </div>
</div>